// src/views/kiddo-games/drag-letters/components/FixedCharZone.tsx
// Kopia src/views/drag-letters/components/FixedCharZone.tsx (oryginał z Regular usunięty) — tylko dla Ułóż słowa Easy
import React, { memo } from 'react';
import classes from '../KiddoDragLettersView.module.less';

interface FixedCharZoneProps {
  char: string;
  showFeedback: boolean;
  isCorrect?: boolean;
}

// Znak hasła, który nie jest literą (kropka, apostrof, cyfra…) — stoi od początku na swoim miejscu, w ramce jak pole
// na literę. Nie przyjmuje kafelków: nie ma go wśród pól w dropZonesRef
export const FixedCharZone = memo(({ char, showFeedback, isCorrect }: FixedCharZoneProps) => {
  let className = `${classes.letterDropZone} ${classes.fixed}`;

  if (showFeedback && isCorrect !== undefined) {
    className += isCorrect ? ` ${classes.correct}` : ` ${classes.incorrect}`;
  }

  return (
    <div className={className}>
      {char}
    </div>
  );
});
